/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { WidthConsumer } from '@atlaskit/editor-common/ui';
import { calcBreakoutWidth } from '@atlaskit/editor-common/utils';
import { blockNodesVerticalMargin } from '@atlaskit/editor-shared-styles';
export const wrapperStyles = css`
  margin: ${blockNodesVerticalMargin} 0;
  margin-left: 50%;
  transform: translateX(-50%);
`;
export default function Breakout(props) {
  return jsx(WidthConsumer, null, ({
    width
  }) => jsx("div", {
    css: wrapperStyles,
    "data-mode": props.mode,
    style: {
      width: calcBreakoutWidth(props.mode, width)
    },
    className: "fabric-editor-breakout-mark fabric-editor-block-mark"
  }, props.children));
}